// A GROUP'S NAME, PICKED (D-402, D-410): one of the vendor's established
// groups, or a new name typed here, which the save adds for the vendor. One
// control wherever a group is named — the bulk row's Group, and a group row's
// own Description (owner, 2026-10-23 — D-410: "I would just offer it in both
// places if you are going to offer it in one").
import { EntityPicker, type EntityOption } from './EntityPicker'
import { loadLineGroups } from '../lib/data'
import { newGroupLabel, typedGroupName } from '../lib/groupNameOptions'

interface Props {
  /** The name as it stands; empty for none. */
  value: string
  /** The invoice's vendor, whose groups are offered; none offers no established group. */
  vendorId: string | null
  onChange: (name: string) => void
  ariaLabel: string
  placeholder?: string
  mountNode?: HTMLElement | null
  disabled?: boolean
  invalid?: boolean
  className?: string
}

/** The option id a name travels under, so a typed name and a listed one compare alike. */
const optionId = (name: string) => `group:${name}`

export function GroupNamePicker({ value, vendorId, onChange, ariaLabel, placeholder, mountNode, disabled, invalid, className }: Props) {
  return (
    <EntityPicker
      size="small"
      className={className}
      ariaLabel={ariaLabel}
      placeholder={placeholder}
      value={value === '' ? {} : { id: optionId(value), name: value }}
      mountNode={mountNode}
      disabled={disabled}
      invalid={invalid}
      optionsKey={vendorId ?? ''}
      search={async (t) => {
        const established = await loadLineGroups(vendorId).catch(() => [])
        const q = typedGroupName(t)
        const options: EntityOption[] = established
          .filter((g) => q === '' || g.name.toLowerCase().includes(q.toLowerCase()))
          .map((g) => ({ id: optionId(g.name), primary: g.name }))
        // ALWAYS FIRST (D-411), even before anything is typed. A name already
        // among the vendor's groups is that group, so it is the same choice.
        return [{ id: optionId(q), primary: newGroupLabel(q), boxText: q }, ...options]
      }}
      onSelect={(o) => {
        const name = o.id.slice(optionId('').length)
        if (name !== '') onChange(name)
      }}
    />
  )
}
